<template>
  <el-dialog title="添加活动产品" :visible.sync="modalShow" append-to-body>
    <el-form :model="searchForm" ref="searchForm" size="small" inline>
      <el-form-item label="班级名称" prop="skuName">
        <el-input v-model.trim="searchForm.skuName" placeholder="产品名称" />
      </el-form-item>
      <el-form-item label=" " label-width="100px">
        <el-button type="primary" @click="search('searchForm')">查询</el-button>
        <el-button @click="reset('searchForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="end">
      <el-col :span="4">
        <el-button type="primary" @click="submit()" size="small">添加至活动</el-button>
      </el-col>
    </el-row>
    <br>
    <el-table border stripe v-loading="loading" :data="tableData" style="width: 100%" ref="table" @selection-change="handleSelectionChange">
      <el-table-column type="selection" :selectable="checkAble" minWidth="80" align="center"></el-table-column>
      <el-table-column prop="spuName" label="产品名称" minWidth="250" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="spuCode" label="产品代码" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="skuName" label="班级名称" minWidth="250" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="publishFlag" label="班级发布状态" minWidth="150" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.publishFlag == 1">未发布</template>
          <template v-else-if="scope.row.publishFlag ==2">已发布</template>
          <template v-else>--</template>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
    </el-table>
    <br>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit()">添加返回</el-button>
      <el-button @click="modalShow = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import tableMoudel from "@/libs/mixin/table";
import { Admin } from "../api"
export default {
  mixins: [tableMoudel],
  data () {
    return {
      modalShow: false,
      searchForm: {
        skuName: null
      },
      selectIds: [],
      spId: null
    }
  },
  watch: {
    modalShow: {
      handler (value) { if (!value) { this.$refs['searchForm'].resetFields() } },
    }
  },
  methods: {
    init (spId) {
      this.modalShow = true
      this.spId = spId
      this.getData()
    },
    checkAble(row){
      return row.checkFlag != 1
    },
    handleSelectionChange (val) {
      this.selectIds = val.map(item => item.skuId)
    },
    async submit () {
      if (this.selectIds.length == 0) {
        this.$message.warning('请选择要添加的数据!')
        return false
      }
      const idstotal = Number(this.selectIds.length) + Number(this.$attrs.total)
      if (idstotal > 70) {
        this.$message.warning('添加班级超出活动限制。')
        return false
      }
      const params = {
        skuIds: this.selectIds.join(','),
        spId: this.spId
      }
      const res = await Admin.addActivitySpSku(params)
      if (res.code !== 0) return
      this.$message.success('操作成功！')
      this.modalShow = false
      this.$bus.$emit('update', true)
    },
    async getData () {
      const params = { ...this.pageInfo, ...this.searchForm }
      params.spId = this.spId
      const res = await Admin.getSkuList(params)
      if (res.code !== 0) return
      const { records } = res.data
      this.tableData = records
      this.total = Number(res.data.total)
    }
  }
}
</script>

<style>
</style>